import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DashboardModel } from '@generativ/much-smarter-models';

import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../../core/services/error-handler.service';
import { LessonModel, StudentSubjectStatsModel, StudentDashboardStatsModel } from '@generativ/much-smarter-models';


@Injectable({ providedIn: 'root' })
export class DashboardService {

  // Todo: Change this for real endpoint
  private dashboardUrl = environment.msStudentApiUrl + 'dashboard/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }

  /**
   * This method get all the dashboard related info.
   *
   * @returns
   */
  getDashboardInfo(): Observable<DashboardModel> {
    return this.http.get<DashboardModel>(this.dashboardUrl + 'dashboardInfo').pipe(
      catchError(this.errorHandlerService.handleError));
  }

  /**
   * Return lessons by subject, ordered by course lesson order.
   *
   * @param courseId - id of course
   * @param subject - subject string
   */
  getLessonBySubjects(courseId: number, subject: string): Observable<LessonModel[]> {
    return this.http.get<LessonModel[]>(`${environment.msStudentApiUrl}courses/${courseId}/lessons?subject=${subject}`).pipe(
      map(lessons => {
        const orderedLessons: LessonModel[] = [];
        if (lessons.length > 0) {
          for (const order of lessons[0].course['_orderLessons'].split(',')) {
            const lesson = lessons.find(l => l.id.toString() === order);
            if (lesson) {
              orderedLessons.push(lesson);
            }
          }
          return orderedLessons;
        }
        return lessons;
      }),
      catchError(this.errorHandlerService.handleError));
  }

  getStudentCourseProgress(courseId: number): Observable<number> {
    return this.http.get<number>(this.dashboardUrl + `${courseId}/progress`).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getStudentDashboardStats(courseId: number): Observable<StudentDashboardStatsModel> {
    return this.http.get<StudentDashboardStatsModel>(this.dashboardUrl + `${courseId}/stats`).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getStudentSubjectStats(courseId: number, subject: string): Observable<StudentSubjectStatsModel> {
    return this.http.get<StudentSubjectStatsModel>(this.dashboardUrl + `${courseId}/stats/subject?subject=${subject}`).pipe(
      catchError(this.errorHandlerService.handleError));
  }

}
